export {
  RequestStatemenDto as RequestStatement,
  RequestStatementResponse,
  GetStatementsByRequestIdDto as StatementRequest,
  StatementByRequestIdResponse as StatementResponse,
  StatementReplyHistoryPerDeptRequestDto as StatementReplyHistoryPerDeptRequest,
  StatementReplyHistoryPerDeptResponseDto as StatementReplyHistoryPerDeptResponse
} from '@proxy/real-estate-ownership-requests-statements';
